import React, { useState } from 'react';
import { Input, Spin } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import { Redirect } from 'react-router-dom';
import BaconButton from '../../shared/components/Button';
import AUTH_MUTATIONS from '../../graphql/auth/mutations';
import { setUserLogin } from '../../shared/utils/auth';
import { useUserContext } from '../../shared/hooks';
import { getError } from '../../shared/utils/errors';
import { useAPIError } from '../../shared/hooks';
import { Box, LoginHeading, InputsContainer, ErrorContainer, ButtonContainer } from './shared/AuthComponents';

const LoginScreen = () => {

  const [showInputs, setShowInputs] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [error, setError] = useState('');

  const userConsumer = useUserContext();
  const { addError } = useAPIError();

  const [login, { loading }] = useMutation(AUTH_MUTATIONS.AUTH_LOGIN, {
    onCompleted (data) {
      if (data?.loginResponse?.access_token) {
        const responseUser = data?.loginResponse?.user;
        setUserLogin({
          accessToken: data?.loginResponse?.access_token,
          rt: data?.loginResponse?.refresh_token,
          userConsumer,
          userId: responseUser.id,
          userIsAdmin: responseUser.is_admin,
          eulaAccepted: responseUser.eula_accepted,
          permissions: responseUser.permissions,
          passwordUpdateRequired: responseUser.password_update_required,
          organization: responseUser.organization,
          username: username.split('@')[0],
        });
      }
    }
  });

  if (userConsumer.user.passwordUpdateRequired) {
    return <Redirect to="/password" />;
  } else if (userConsumer.user && userConsumer.user.loggedIn && !userConsumer.user.passwordUpdateRequired) {
    return <Redirect to="/" />;
  }

  const onClickHandler = () => {
    setShowInputs(true);
    if (username && password) {
      const variables = {
        email: username,
        password: password,
      };
      login({ variables }).catch(error => {
        const { errorMessage, errorStatus } = getError(error);
        addError(errorMessage, errorStatus);
        setError(errorMessage.Error);
      });
    }
  };

  return (
    <Box>
      <LoginHeading>
        Bacon Grease
      </LoginHeading>
      Frictionless Bacon Management
      <InputsContainer>
        {showInputs && (
          <>
            <Input
              placeholder="Username"
              size="middle"
              value={username}
              onChange={e => setUsername(e.target.value)}
              onPressEnter={onClickHandler}
            />
            <Input.Password
              placeholder="Password"
              size="small"
              value={password}
              onChange={e => setPassword(e.target.value)}
              onPressEnter={onClickHandler}
            />
          </>
        )}
        <ErrorContainer>{loading ? <Spin /> : error}</ErrorContainer>
      </InputsContainer>
      <ButtonContainer>
        <BaconButton text="Login" onClick={onClickHandler}></BaconButton>
      </ButtonContainer>
    </Box>
  );
};

export default LoginScreen;